import clsx from 'clsx'

import PercentChange from 'components/PercentChange'

import s from './StatCard.module.css'

type Props = {
  title: string
  value: number
  change?: number
  isActive?: boolean
  showDot?: boolean
  isCurrency?: boolean
}

const StatCard = ({
  title,
  value,
  change,
  isActive,
  showDot = false,
  isCurrency = false,
}: Props) => {
  const formattedValue = isCurrency
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value)
    : new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
      }).format(value)

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        {showDot && (
          <div
            className={clsx(s.dot, {
              [s.active]: isActive,
            })}
          />
        )}
        {title}
      </div>
      <div className={s.valueWrapper}>
        <div className={s.value}>{formattedValue}</div>
        {!!change && <PercentChange change={change} />}
      </div>
    </div>
  )
}

export default StatCard
